<div [formGroup]="frequencyCap" class="frequency-cap">
    <targeting-container label="FREQUENCY" [hideRemove]="true" [hideEdit]="true">
        <div class="row" [ngClass]="{ 'error': frequencyCap.touched && frequencyCap.errors }">
            <div class="col-3" id="DL-value{{group+1}}">
                <acl-ngx-input contentClass="planner-input" formControlName="value" type="number" accept="number"
                    min="0">
                </acl-ngx-input>
            </div>
            <label class="freq-impression-label">impression per</label>
            <div class="col-3" id="DL-period{{group+1}}">
                <acl-ngx-input contentClass="planner-input" formControlName="period" type="number" accept="number"
                    min="0">
                </acl-ngx-input>
            </div>
            <div class="col-3 freq-time-frame">
                <acl-ngx-select (change)="handleOnSelectChange($event)"
                    [initialValue]="{'value': timeFrame.value, 'label': timeFrames[timeFrame.value]}" menuWidth="180px"
                    [irreversible]="true">
                    <acl-ngx-option *ngFor="let enum of timeFrames | keyvalue" [label]="enum.value" [value]="enum.key">
                    </acl-ngx-option>
                </acl-ngx-select>
            </div>
        </div>
        <div *ngIf="frequencyCap.touched && frequencyCap.errors" class="error-feedback">
            <span>Please set both number of impressions and a time period</span>
        </div>
    </targeting-container>
</div>